import React from 'react';
import Banner from './Banner';
import Cards from './Cards';
import ResumeSection from './ResumeSection';
import NewsSection from './NewsSection';
import Important from './Important';
import UploadSection from './UploadSection';
import Footer from './Footer';
import RateButton from './RateButton';
// import RateButton from './RateButton';

const Home = () => {
    return (
        <div>
            <Banner/>
            <Cards/>
            <ResumeSection/>
            <Important/>
            <NewsSection/>
            <UploadSection/>
            <Footer/>
        </div>
    );
}

export default Home;
